import { buildTx, getQuote, type QuoteResponse } from '@7kprotocol/sdk-ts';
import { Transaction, type TransactionObjectArgument } from '@mysten/sui/transactions';

interface BestRouteOptions {
  tokenInType: string;
  tokenOutType: string;
  amountIn: string;
}

export class K7Aggregator {
  static async findBestRoute(data: BestRouteOptions): Promise<QuoteResponse> {
    const quote = await getQuote({
      tokenIn: data.tokenInType,
      tokenOut: data.tokenOutType,
      amountIn: data.amountIn,
    });
    if (!quote.routes?.length) throw new Error('No route');
    return quote;
  }

  static async buildTransaction(
    quoteResponse: QuoteResponse,
    slippage: string,
    address: string,
    extendTx?: {
      tx: Transaction;
      coinIn?: TransactionObjectArgument;
    },
  ): Promise<{
    tx: Transaction;
    coinOut: TransactionObjectArgument | undefined;
  }> {
    const result = await buildTx({
      quoteResponse,
      accountAddress: address,
      slippage,
      commission: {
        partner: '0x03b8b31cb1de9bca0fa9fcba69a2860928496d0bbcdba8376aa5e30944d9a79d',
        commissionBps: 0,
      },
      extendTx,
    });

    return result;
  }
}
